export default __webpack_public_path__ + "static/media/apple-store.fc12e815.png";